export enum LocalStorageKey {
  VerificationEmailLimitCountdown = 'verification-email-limit-countdown',
  ClientId = 'clientId',
  SigninMethod = 'signinMethod',
  AccountsVerificationCodeReminder = 'accounts_verification_code_reminder',
  HdCouponCode = 'hd-coupon-code',
  SignupTabChanged = 'signupTabChanged',
  SignupAlertTriggered = 'signupAlertTriggered',
  SignupAuthMethod = 'signupAuthMethod',
}
